import { reactive } from 'vue'
export default <T>(list: T[] = [], key: string): any => {
  const checkMap: any = reactive({})
  list.filter((v) => !!v).forEach((v: any) => {
    checkMap[v[key]] = v
  })
  const change = (val: any, is: boolean | void) => {
    const id = val[key]
    const check = is ?? !(id in checkMap)
    if (check) {
      checkMap[id] = val
    } else {
      delete checkMap[id]
    }
  }
  const hasCheck = (val: any) => val[key] in checkMap
  return [checkMap, change, hasCheck]
}

// 用于与UseEdit配合
export const useWrap = <T>(list: T[], key: string): any => {
  const checkMap: any = {}
  list.forEach((v: any) => {
    checkMap[v[key]] = v
  })
  const change = (checkMap: any) => {
    return (val: any, is: boolean | void) => {
      const id = val[key]
      const check = is ?? !(id in checkMap)
      if (check) {
        checkMap[id] = val
      } else {
        delete checkMap[id]
      }
    }
  }
  return [checkMap, change]
}
